// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___EsT7","icon":"styles_icon__ipp3N","title":"styles_title__0D7ck","description":"styles_description__4SVLU","useDifferentAccountButton":"styles_useDifferentAccountButton___s1SH"};
module.exports.__checksum = "401dd357c999"
